import {
  EXCLUDED_ENTRY_POINT,
  TOGGLE_IS_TEMPORARY_HIDDEN,
  RECEIVE_ULP_BANNER_DATA,
  RECEIVE_ULP_BANNER_DATA_ERROR,
  USER_HID_BANNER,
} from '../actions/ulp';

export const initialState = {
  cookies: {},
  isTemporaryHidden: false,
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case EXCLUDED_ENTRY_POINT: {
      const cookies = { ...state.cookies, excludedEntryPoint: true };
      return { ...state, cookies };
    }
    case TOGGLE_IS_TEMPORARY_HIDDEN: {
      return { ...state, isTemporaryHidden: action.isTemporaryHidden };
    }
    case RECEIVE_ULP_BANNER_DATA: {
      return { ...state, ...action.ulp };
    }
    case RECEIVE_ULP_BANNER_DATA_ERROR: {
      return { ...initialState, error: action.error };
    }
    case USER_HID_BANNER: {
      const cookies = { ...state.cookies, userHidBanner: true };
      return { ...state, cookies };
    }
    default:
      return state;
  }
}
